export default __webpack_public_path__ + "static/media/success.14d44170.svg";